import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Tile from '../tile/Tile';
import CustomerHeader from './CustomerHeader';
import BranchListContainer from '../../containers/BranchListContainer';
import BranchListFilter from '../branchList/BranchListFilter';
import translate from '../../lib/i18n/translate'
import numeral from 'numeral';
import ExportForm from '../../components/export/ExportForm';
import moment from 'moment';
import {ROOT_URL} from '../../store/actions/util'
import {ChartSlider} from "../chart/ChartSlider";
import FontIcon from 'material-ui/FontIcon';
import {LoomisColors} from '../../lib/LoomisColors';

const Customer = (props) => {
    const {customer, showWarnings, showMap, mobile, strings} = props;
    const {openExportDialog, exportDialog} = props;
    const {closeExportDialog, cancelExportDialog} = props;
    const {fetchFilteredBranches} = props;

    const {SafesOnline, ActiveWarnings, CurrentBalance, DailySales, Of, In, Branches} = strings;

    const iconStyle = {
        fontSize: '1.2rem',
        color:LoomisColors.white
    };

    const handleExportDialogClose = (range) => {
        if(range){

            let startTime = moment(range.start).format("YYYY-MM-DD HH:mm:ss");
            let endTime = moment(range.end).format("YYYY-MM-DD HH:mm:ss");

            let url = ROOT_URL+ "/api/v1/customers/" + customer.id + "/transactions/export?"
                +"startDate=" + encodeURIComponent(startTime)
                + "&endDate=" + encodeURIComponent(endTime);

            closeExportDialog(range);

            window.open(url);

        } else {
            cancelExportDialog(range);
        }
    };

    return (
        <div>
            <ExportForm open={exportDialog.open}
                        start={exportDialog.range.start}
                        end={exportDialog.range.end}
                        handleClose={handleExportDialogClose}/>
            <div className="dark">
            <div className="container">
            <Grid fluid className="dark">
                <Row>
                    <Col xs={12}>
                        <CustomerHeader customer={customer} showMap={showMap} branchCount={customer.totalBranches} openExportDialog={openExportDialog}/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <ChartSlider periodLength={mobile?7:undefined} mainCurrency={customer.mainCurrency} salesByDate={customer.salesByDate}  />
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} sm={6} md={3} lg={3} >
                        <Tile type="online" title={SafesOnline} data={{online:customer.devicesTotal-customer.devicesOffline, of: Of, total: customer.devicesTotal}}/>
                    </Col>
                    <Col xs={6} sm={6} md={3} lg={3} >
                        <Tile type="warnings" title={ActiveWarnings} data={{problems: customer.problemsTotal, in: In, problemBranches: customer.problemsBranches, branches: Branches}} onClick={()=>showWarnings()}/>
                    </Col>
                    <Col xs={6} sm={6} md={3} lg={3} >
                        <Tile type="balance" title={CurrentBalance} data={
                            customer.balanceThisDay.map((b,i) => <div key={i}><div className="Amount">{numeral(b.amount/100).format('0,0.00')}</div><div className="Currency">{b.currency}</div></div>)
                        }/>
                    </Col>
                    <Col xs={6} sm={6} md={3} lg={3} >
                        <Tile type="sales" title={DailySales} data={
                            customer.salesThisDay.map((b,i) => 
                            <div key={i}>
                                <div className="Amount">{numeral((b.processedAmount+b.unProcessedAmount)/100).format('0,0.00')}</div>
                                <div className="AmountSmall">{<FontIcon className="material-icons" style={iconStyle}>cached</FontIcon>}  {numeral(b.processedAmount/100).format('0,0.00')}  {<FontIcon className="material-icons" style={iconStyle}>mail_outline</FontIcon>} {numeral(b.unProcessedAmount/100).format('0,0.00')}</div>
                                <div className="Currency">{b.currency}</div>
                            </div>)
                        }/>
                    </Col>
                </Row>
            </Grid>
            </div>
            </div>
            <div className="container">
                <Grid fluid className="noXsPadding">
                    <Row>
                        <Col xs={12}>
                            <BranchListFilter fetchFilteredBranches={fetchFilteredBranches}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <BranchListContainer customerId={customer.id}/>
                        </Col>
                    </Row>
                </Grid>
            </div>
        </div>
    )
};

export default translate('Customer')(Customer);




// WEBPACK FOOTER //
// ./src/components/customer/Customer.js